import { render, staticRenderFns } from "./DataReportFeeStatistics.vue?vue&type=template&id=24e0a16e&scoped=true"
import script from "./DataReportFeeStatistics.vue?vue&type=script&lang=js"
export * from "./DataReportFeeStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataReportFeeStatistics.vue?vue&type=style&index=0&id=24e0a16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0a16e",
  null
  
)

export default component.exports